// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from '../api/apiSlice'

  export const satpasDeviceApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllOcspList: builder.query<any, any>({
            query: params => {
                return {
                    url: `/ocsp/ocsp-configure`,
                    params: params
                }
            },
            providesTags:['GetAllOcspList'],
        })
  })
})

export const {
useGetAllOcspListQuery
} = satpasDeviceApiSlice;